import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from '../images/logo.png';

function DashboardSideMenu() {
  const location = useLocation();
  const currentPath = location.pathname;

  const isActive = (path) => currentPath === path;

  const navigate = useNavigate();
  
  const handleLogout = () => {
    localStorage.removeItem('token'); // Remove token from localStorage on logout
    navigate('/'); // Redirect to Home page after logout
  };

  return (
    <div
      id="sidebar-wrapper"
      data-simplebar=""
      data-simplebar-auto-hide="true"
    >
      <div className="brand-logo">
        <Link to="/dashboard">
          <img src={Logo} alt="Learning Aids" />
        </Link>
      </div>
      <ul className="sidebar-menu do-nicescrol">
        <li className="sidebar-header">MAIN NAVIGATION</li>

        <li className={isActive('/dashboard') ? 'active' : ''}>
          <Link to="/dashboard" className="wave-effect">
            <i className="icon-home"></i> <span>Dashboard</span>
          </Link>
        </li>

        <li className={isActive('/dashboard/calendar') ? 'active' : ''}>
          <Link to="/dashboard/calendar" className="wave-effect">
            <i className="icon-calendar"></i> <span>Calendar</span>
          </Link>
        </li>

        <li className={isActive('/dashboard/profile/courses') ? 'active' : ''}>
          <Link to="/dashboard/profile/courses" className="wave-effect">
            <i className="fa fa-book"></i> <span>Courses</span>
          </Link>
        </li>

        <li className={isActive('/dashboard/profile/quizzes') ? 'active' : ''}>
          <Link to="/dashboard/profile/quizzes" className="wave-effect">
            <i className="fa fa-tasks"></i> <span>Quizzes</span>
          </Link>
        </li>

        <li className={isActive('/dashboard/profile') ? 'active' : ''}>
          <Link to="/dashboard/profile" className="wave-effect">
            <i className="icon-user"></i> <span>Profile</span>
          </Link>
        </li>

        <li className={isActive('/dashboard/messages') ? 'active' : ''}>
          <Link to="/dashboard/messages" className="wave-effect">
            <i className="fa fa-envelope-open"></i> <span>Messages</span>
          </Link>
        </li>

        <li className={isActive('/dashboard/settings') ? 'active' : ''}>
          <Link to="/dashboard/settings" className="wave-effect">
            <i className="icon-settings"></i> <span>Settings</span>
          </Link>
        </li>

        <li>
          <Link to="/" className="wave-effect" onClick={handleLogout}>
            <i className="fa fa-sign-out"></i> <span>Logout</span>
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default DashboardSideMenu;
